import {
  BackBar,
  describeError,
  MEMBER_ERRORS,
  type MemberFormValues,
  toMemberFields,
} from '@horof/shared';
import { Alert } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useMutation } from 'urql';
import { MemberForm } from './MemberForm';
import { CreateMemberDocument } from './members-data';

/** «عضو جديد», then their page (to add a meter with its photo). */
export function NewMemberPage() {
  const navigate = useNavigate();
  const [{ fetching }, createMember] = useMutation(CreateMemberDocument);
  const [problem, setProblem] = useState<string | null>(null);

  async function create(values: MemberFormValues) {
    setProblem(null);
    const result = await createMember(
      { member: toMemberFields(values) },
      { additionalTypenames: ['Member'] },
    );
    const id = result.data?.createMember?.member?.id;
    if (result.error || !id) {
      setProblem(
        describeError(result.error, 'تعذّر إضافة العضو.', MEMBER_ERRORS),
      );
      return;
    }
    navigate(`/members/${id}`, { replace: true });
  }

  return (
    <div className="page">
      <BackBar to="/members" label="الأعضاء" />
      <h1 className="member-title">عضو جديد</h1>
      {problem && <Alert type="error" showIcon message={problem} />}
      <MemberForm
        initialValues={{}}
        saving={fetching}
        submitLabel="إضافة العضو"
        onSubmit={create}
      />
    </div>
  );
}
